function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_569",
  "data-name": "Rectangle 569",
  width: 768,
  height: 261,
  transform: "translate(1152 827)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_541",
  "data-name": "Rectangle 541",
  width: 890,
  height: 334,
  transform: "translate(-0.222 0.44)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 1
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2264",
  "data-name": "Group 2264",
  transform: "translate(-530.991 13.552)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2262",
  "data-name": "Group 2262",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_10565",
  "data-name": "Path 10565",
  d: "M519.738,173.915a6.493,6.493,0,1,0,6.495-6.492A6.491,6.491,0,0,0,519.738,173.915Z",
  transform: "translate(1003.576 306.64)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10566",
  "data-name": "Path 10566",
  d: "M28.738,47.415a6.493,6.493,0,1,0,6.495-6.492A6.491,6.491,0,0,0,28.738,47.415Z",
  transform: "translate(39.805 58.336)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10568",
  "data-name": "Path 10568",
  d: "M268.908,97.962a6.492,6.492,0,1,0,6.492-6.495A6.494,6.494,0,0,0,268.908,97.962Z",
  transform: "translate(511.228 157.548)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10569",
  "data-name": "Path 10569",
  d: "M53.87,119.514a6.492,6.492,0,1,0,6.492-6.492A6.494,6.494,0,0,0,53.87,119.514Z",
  transform: "translate(89.136 199.857)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10571",
  "data-name": "Path 10571",
  d: "M250.535,150.992a3.653,3.653,0,1,0,3.656-3.653A3.655,3.655,0,0,0,250.535,150.992Z",
  transform: "translate(475.165 267.217)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10572",
  "data-name": "Path 10572",
  d: "M267.984,171.518a3.653,3.653,0,1,0,3.659-3.65A3.656,3.656,0,0,0,267.984,171.518Z",
  transform: "translate(509.415 307.513)",
  fill: "#48c4f5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10573",
  "data-name": "Path 10573",
  d: "M145.446,221.287a3.653,3.653,0,1,0,3.659-3.656A3.656,3.656,0,0,0,145.446,221.287Z",
  transform: "translate(268.888 405.192)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10574",
  "data-name": "Path 10574",
  d: "M231.595,281.033a3.652,3.652,0,1,0,3.656-3.656A3.653,3.653,0,0,0,231.595,281.033Z",
  transform: "translate(437.988 522.466)",
  fill: "#48c4f5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10575",
  "data-name": "Path 10575",
  d: "M43.709,310.388a3.653,3.653,0,1,0,3.653-3.65A3.656,3.656,0,0,0,43.709,310.388Z",
  transform: "translate(69.191 580.098)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10576",
  "data-name": "Path 10576",
  d: "M76.029,104.365a3.653,3.653,0,1,0,3.653-3.65A3.653,3.653,0,0,0,76.029,104.365Z",
  transform: "translate(132.631 175.7)",
  fill: "#ffe358"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10578",
  "data-name": "Path 10578",
  d: "M335.348,144.85a2.51,2.51,0,1,0,2.507-2.513A2.507,2.507,0,0,0,335.348,144.85Z",
  transform: "translate(641.642 257.399)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10579",
  "data-name": "Path 10579",
  d: "M407.485,98.914A2.511,2.511,0,1,0,410,96.4,2.509,2.509,0,0,0,407.485,98.914Z",
  transform: "translate(783.238 167.238)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10580",
  "data-name": "Path 10580",
  d: "M412.1,130.731a2.511,2.511,0,1,0,2.513-2.507A2.507,2.507,0,0,0,412.1,130.731Z",
  transform: "translate(792.304 229.697)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10581",
  "data-name": "Path 10581",
  d: "M381.311,125.6a2.511,2.511,0,1,0,2.513-2.51A2.509,2.509,0,0,0,381.311,125.6Z",
  transform: "translate(731.861 219.622)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_526",
  "data-name": "Ellipse 526",
  cx: 2.509,
  cy: 2.509,
  r: 2.509,
  transform: "translate(1110.037 458.182)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10582",
  "data-name": "Path 10582",
  d: "M349.973,150.714a2.51,2.51,0,1,0,2.51-2.507A2.509,2.509,0,0,0,349.973,150.714Z",
  transform: "translate(670.349 268.921)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10583",
  "data-name": "Path 10583",
  d: "M391.171,144.439a3.763,3.763,0,1,0,3.763-3.763A3.763,3.763,0,0,0,391.171,144.439Z",
  transform: "translate(751.215 254.139)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10584",
  "data-name": "Path 10584",
  d: "M369.659,147.836a3.763,3.763,0,1,0,3.766-3.763A3.764,3.764,0,0,0,369.659,147.836Z",
  transform: "translate(708.99 260.807)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10585",
  "data-name": "Path 10585",
  d: "M363.659,161.836a3.763,3.763,0,1,0,3.766-3.763A3.764,3.764,0,0,0,363.659,161.836Z",
  transform: "translate(697.213 288.287)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10586",
  "data-name": "Path 10586",
  d: "M449.171,110.209a3.763,3.763,0,1,0,3.763-3.763A3.761,3.761,0,0,0,449.171,110.209Z",
  transform: "translate(865.062 186.95)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10587",
  "data-name": "Path 10587",
  d: "M421.659,127.606a3.763,3.763,0,1,0,3.766-3.763A3.762,3.762,0,0,0,421.659,127.606Z",
  transform: "translate(811.059 221.098)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10589",
  "data-name": "Path 10589",
  d: "M347.941,170.71a3.763,3.763,0,1,0,3.766-3.763A3.766,3.766,0,0,0,347.941,170.71Z",
  transform: "translate(666.36 305.705)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10590",
  "data-name": "Path 10590",
  d: "M329.564,189.107a3.763,3.763,0,1,0,3.766-3.763A3.764,3.764,0,0,0,329.564,189.107Z",
  transform: "translate(630.289 341.816)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10591",
  "data-name": "Path 10591",
  d: "M327.671,200.941a3.763,3.763,0,1,0,3.763-3.766A3.761,3.761,0,0,0,327.671,200.941Z",
  transform: "translate(626.573 365.039)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10592",
  "data-name": "Path 10592",
  d: "M300.159,218.333a3.763,3.763,0,1,0,3.766-3.76A3.764,3.764,0,0,0,300.159,218.333Z",
  transform: "translate(572.57 399.189)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10593",
  "data-name": "Path 10593",
  d: "M252.43,213.109a3.763,3.763,0,1,0,3.763-3.766A3.761,3.761,0,0,0,252.43,213.109Z",
  transform: "translate(478.884 388.923)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10594",
  "data-name": "Path 10594",
  d: "M100.991,259.167a3.763,3.763,0,1,0,3.766-3.763A3.766,3.766,0,0,0,100.991,259.167Z",
  transform: "translate(181.629 479.335)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10595",
  "data-name": "Path 10595",
  d: "M150.324,309.833a3.763,3.763,0,1,0,3.766-3.763A3.766,3.766,0,0,0,150.324,309.833Z",
  transform: "translate(278.463 578.786)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10596",
  "data-name": "Path 10596",
  d: "M226.671,209.441a3.763,3.763,0,1,0,3.763-3.766A3.761,3.761,0,0,0,226.671,209.441Z",
  transform: "translate(428.323 381.724)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10597",
  "data-name": "Path 10597",
  d: "M199.159,226.833a3.763,3.763,0,1,0,3.766-3.76A3.764,3.764,0,0,0,199.159,226.833Z",
  transform: "translate(374.32 415.874)",
  fill: "#ffe358"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10598",
  "data-name": "Path 10598",
  d: "M178.992,253.109a3.763,3.763,0,1,0,3.766-3.766A3.761,3.761,0,0,0,178.992,253.109Z",
  transform: "translate(334.735 467.438)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10599",
  "data-name": "Path 10599",
  d: "M175.063,268.609a3.763,3.763,0,1,0,3.766-3.766A3.763,3.763,0,0,0,175.063,268.609Z",
  transform: "translate(327.023 497.863)",
  fill: "#ffe358"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10600",
  "data-name": "Path 10600",
  d: "M168.659,301.414a3.763,3.763,0,1,0,3.766-3.76A3.764,3.764,0,0,0,168.659,301.414Z",
  transform: "translate(314.452 562.267)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10601",
  "data-name": "Path 10601",
  d: "M120.93,265.609a3.763,3.763,0,1,0,3.763-3.766A3.761,3.761,0,0,0,120.93,265.609Z",
  transform: "translate(220.766 491.974)",
  fill: "#ffe358"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10602",
  "data-name": "Path 10602",
  d: "M254.171,226.941a3.763,3.763,0,1,0,3.763-3.766A3.761,3.761,0,0,0,254.171,226.941Z",
  transform: "translate(482.302 416.074)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10603",
  "data-name": "Path 10603",
  d: "M306.324,291.167a3.763,3.763,0,1,0,3.766-3.763A3.766,3.766,0,0,0,306.324,291.167Z",
  transform: "translate(584.671 542.147)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10604",
  "data-name": "Path 10604",
  d: "M478.659,318.188a3.763,3.763,0,1,0,3.766-3.763A3.762,3.762,0,0,0,478.659,318.188Z",
  transform: "translate(922.943 595.186)",
  fill: "#ffe358"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10605",
  "data-name": "Path 10605",
  d: "M503.159,332.414a3.763,3.763,0,1,0,3.766-3.76A3.764,3.764,0,0,0,503.159,332.414Z",
  transform: "translate(971.034 623.116)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10611",
  "data-name": "Path 10611",
  d: "M278.93,79.609a3.763,3.763,0,1,0,3.763-3.766A3.761,3.761,0,0,0,278.93,79.609Z",
  transform: "translate(530.9 126.88)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10612",
  "data-name": "Path 10612",
  d: "M198.93,104.109a3.763,3.763,0,1,0,3.763-3.766A3.761,3.761,0,0,0,198.93,104.109Z",
  transform: "translate(373.87 174.97)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10613",
  "data-name": "Path 10613",
  d: "M486.389,59.108a3.763,3.763,0,1,0,3.763-3.766A3.761,3.761,0,0,0,486.389,59.108Z",
  transform: "translate(938.116 86.639)",
  fill: "#ffe358"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10619",
  "data-name": "Path 10619",
  d: "M317.671,51.441a3.763,3.763,0,1,0,3.763-3.766A3.761,3.761,0,0,0,317.671,51.441Z",
  transform: "translate(606.944 71.59)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10620",
  "data-name": "Path 10620",
  d: "M290.159,68.833a3.763,3.763,0,1,0,3.766-3.76A3.764,3.764,0,0,0,290.159,68.833Z",
  transform: "translate(552.942 105.74)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10621",
  "data-name": "Path 10621",
  d: "M242.43,63.609a3.763,3.763,0,1,0,3.763-3.766A3.761,3.761,0,0,0,242.43,63.609Z",
  transform: "translate(459.256 95.474)",
  fill: "#48c4f5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10622",
  "data-name": "Path 10622",
  d: "M225.659,102.336a3.763,3.763,0,1,0,3.766-3.763A3.764,3.764,0,0,0,225.659,102.336Z",
  transform: "translate(426.336 171.496)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10623",
  "data-name": "Path 10623",
  d: "M236.889,91.565a3.763,3.763,0,1,0,3.763-3.763A3.761,3.761,0,0,0,236.889,91.565Z",
  transform: "translate(448.379 150.354)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10624",
  "data-name": "Path 10624",
  d: "M189.159,86.336a3.763,3.763,0,1,0,3.766-3.763A3.764,3.764,0,0,0,189.159,86.336Z",
  transform: "translate(354.691 140.09)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10625",
  "data-name": "Path 10625",
  d: "M147.992,110.377a3.763,3.763,0,1,0,3.766-3.763A3.764,3.764,0,0,0,147.992,110.377Z",
  transform: "translate(273.886 187.279)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10626",
  "data-name": "Path 10626",
  d: "M163.89,113.607a3.763,3.763,0,1,0,3.763-3.763A3.761,3.761,0,0,0,163.89,113.607Z",
  transform: "translate(305.091 193.619)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10627",
  "data-name": "Path 10627",
  d: "M92.326,100.44a3.763,3.763,0,1,0,3.766-3.763A3.766,3.766,0,0,0,92.326,100.44Z",
  transform: "translate(164.62 167.774)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10628",
  "data-name": "Path 10628",
  d: "M84.324,29.708a3.763,3.763,0,1,0,3.766-3.763A3.766,3.766,0,0,0,84.324,29.708Z",
  transform: "translate(148.913 28.936)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10629",
  "data-name": "Path 10629",
  d: "M123.722,19.1a3.763,3.763,0,1,0,3.763-3.763A3.763,3.763,0,0,0,123.722,19.1Z",
  transform: "translate(226.247 8.122)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10630",
  "data-name": "Path 10630",
  d: "M386.083,79.93a2.508,2.508,0,1,0,2.509-2.51A2.509,2.509,0,0,0,386.083,79.93Z",
  transform: "translate(741.228 129.975)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10631",
  "data-name": "Path 10631",
  d: "M400.708,85.8a2.508,2.508,0,1,0,2.51-2.51A2.509,2.509,0,0,0,400.708,85.8Z",
  transform: "translate(769.935 141.495)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10632",
  "data-name": "Path 10632",
  d: "M372.994,81.18a2.51,2.51,0,1,0,2.51-2.51A2.509,2.509,0,0,0,372.994,81.18Z",
  transform: "translate(715.536 132.429)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10633",
  "data-name": "Path 10633",
  d: "M321.083,66.43a2.508,2.508,0,1,0,2.509-2.51A2.509,2.509,0,0,0,321.083,66.43Z",
  transform: "translate(613.641 103.476)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10635",
  "data-name": "Path 10635",
  d: "M307.994,67.68a2.51,2.51,0,1,0,2.51-2.51A2.509,2.509,0,0,0,307.994,67.68Z",
  transform: "translate(587.949 105.93)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10636",
  "data-name": "Path 10636",
  d: "M89.083,85.93a2.51,2.51,0,1,0,2.51-2.51A2.509,2.509,0,0,0,89.083,85.93Z",
  transform: "translate(158.255 141.752)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10637",
  "data-name": "Path 10637",
  d: "M103.708,91.8a2.51,2.51,0,1,0,2.51-2.51A2.509,2.509,0,0,0,103.708,91.8Z",
  transform: "translate(186.962 153.273)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10638",
  "data-name": "Path 10638",
  d: "M75.994,87.18a2.511,2.511,0,1,0,2.513-2.51A2.509,2.509,0,0,0,75.994,87.18Z",
  transform: "translate(132.563 144.206)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10639",
  "data-name": "Path 10639",
  d: "M304.083,85.43a2.51,2.51,0,1,0,2.509-2.51A2.509,2.509,0,0,0,304.083,85.43Z",
  transform: "translate(580.273 140.771)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10640",
  "data-name": "Path 10640",
  d: "M318.708,91.3a2.51,2.51,0,1,0,2.509-2.51A2.509,2.509,0,0,0,318.708,91.3Z",
  transform: "translate(608.98 152.291)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10641",
  "data-name": "Path 10641",
  d: "M290.994,86.68a2.51,2.51,0,1,0,2.513-2.51A2.509,2.509,0,0,0,290.994,86.68Z",
  transform: "translate(554.581 143.225)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10642",
  "data-name": "Path 10642",
  d: "M330.93,124.777a2.51,2.51,0,1,0,2.507-2.51A2.506,2.506,0,0,0,330.93,124.777Z",
  transform: "translate(632.97 218.004)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10643",
  "data-name": "Path 10643",
  d: "M345.555,130.643a2.51,2.51,0,1,0,2.507-2.507A2.509,2.509,0,0,0,345.555,130.643Z",
  transform: "translate(661.677 229.524)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10644",
  "data-name": "Path 10644",
  d: "M282.083,190.43a2.51,2.51,0,1,0,2.509-2.51A2.509,2.509,0,0,0,282.083,190.43Z",
  transform: "translate(537.089 346.873)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10645",
  "data-name": "Path 10645",
  d: "M351.487,178.275a2.511,2.511,0,1,0,2.51-2.507A2.507,2.507,0,0,0,351.487,178.275Z",
  transform: "translate(673.321 323.02)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10646",
  "data-name": "Path 10646",
  d: "M255.153,162.441a2.509,2.509,0,1,0,2.507-2.507A2.508,2.508,0,0,0,255.153,162.441Z",
  transform: "translate(484.229 291.94)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10647",
  "data-name": "Path 10647",
  d: "M297.208,159.794a2.51,2.51,0,1,0,2.509-2.5A2.509,2.509,0,0,0,297.208,159.794Z",
  transform: "translate(566.778 286.75)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10648",
  "data-name": "Path 10648",
  d: "M228.083,186.93a2.51,2.51,0,1,0,2.51-2.51A2.509,2.509,0,0,0,228.083,186.93Z",
  transform: "translate(431.094 340.003)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10649",
  "data-name": "Path 10649",
  d: "M242.708,192.794a2.51,2.51,0,1,0,2.51-2.5A2.509,2.509,0,0,0,242.708,192.794Z",
  transform: "translate(459.801 351.525)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10650",
  "data-name": "Path 10650",
  d: "M214.994,188.18a2.51,2.51,0,1,0,2.512-2.51A2.509,2.509,0,0,0,214.994,188.18Z",
  transform: "translate(405.402 342.456)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10651",
  "data-name": "Path 10651",
  d: "M197.583,308.51a2.51,2.51,0,1,0,2.51-2.509A2.509,2.509,0,0,0,197.583,308.51Z",
  transform: "translate(371.227 578.651)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10652",
  "data-name": "Path 10652",
  d: "M212.208,314.375a2.51,2.51,0,1,0,2.51-2.5A2.509,2.509,0,0,0,212.208,314.375Z",
  transform: "translate(399.934 590.173)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10653",
  "data-name": "Path 10653",
  d: "M184.494,309.76a2.51,2.51,0,1,0,2.512-2.509A2.509,2.509,0,0,0,184.494,309.76Z",
  transform: "translate(345.534 581.104)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10654",
  "data-name": "Path 10654",
  d: "M302.208,313.375a2.51,2.51,0,1,0,2.509-2.5A2.509,2.509,0,0,0,302.208,313.375Z",
  transform: "translate(576.592 588.21)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10655",
  "data-name": "Path 10655",
  d: "M264.986,318.444a2.511,2.511,0,1,0,2.513-2.51A2.507,2.507,0,0,0,264.986,318.444Z",
  transform: "translate(503.53 598.148)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10656",
  "data-name": "Path 10656",
  d: "M183.735,194.277a2.511,2.511,0,1,0,2.51-2.51A2.506,2.506,0,0,0,183.735,194.277Z",
  transform: "translate(344.045 354.424)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10657",
  "data-name": "Path 10657",
  d: "M198.36,200.143a2.511,2.511,0,1,0,2.51-2.507A2.509,2.509,0,0,0,198.36,200.143Z",
  transform: "translate(372.752 365.944)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10658",
  "data-name": "Path 10658",
  d: "M170.646,195.527a2.511,2.511,0,1,0,2.513-2.51A2.507,2.507,0,0,0,170.646,195.527Z",
  transform: "translate(318.353 356.878)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10659",
  "data-name": "Path 10659",
  d: "M293.006,142.57a2.51,2.51,0,1,0,2.507-2.51A2.508,2.508,0,0,0,293.006,142.57Z",
  transform: "translate(558.53 252.93)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10660",
  "data-name": "Path 10660",
  d: "M216.568,167.685a2.513,2.513,0,1,0,2.513-2.51A2.511,2.511,0,0,0,216.568,167.685Z",
  transform: "translate(408.492 302.227)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10661",
  "data-name": "Path 10661",
  d: "M343.814,189.21a2.511,2.511,0,1,0,2.51-2.512A2.511,2.511,0,0,0,343.814,189.21Z",
  transform: "translate(658.26 344.472)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10662",
  "data-name": "Path 10662",
  d: "M280.688,227.187a2.511,2.511,0,1,0,2.513-2.512A2.512,2.512,0,0,0,280.688,227.187Z",
  transform: "translate(534.351 419.018)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10663",
  "data-name": "Path 10663",
  d: "M435.68,17.738a2.51,2.51,0,1,0,2.51-2.513A2.508,2.508,0,0,0,435.68,17.738Z",
  transform: "translate(838.581 7.894)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10664",
  "data-name": "Path 10664",
  d: "M231.934,51.185a2.508,2.508,0,1,0,2.507-2.51A2.506,2.506,0,0,0,231.934,51.185Z",
  transform: "translate(438.653 73.552)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10665",
  "data-name": "Path 10665",
  d: "M89.263,59.279a2.508,2.508,0,1,0,2.507-2.513A2.507,2.507,0,0,0,89.263,59.279Z",
  transform: "translate(158.608 89.434)",
  fill: "#ffe358"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10666",
  "data-name": "Path 10666",
  d: "M65.9,69.279a2.51,2.51,0,1,0,2.51-2.513A2.508,2.508,0,0,0,65.9,69.279Z",
  transform: "translate(112.753 109.063)",
  fill: "#ffe358"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10667",
  "data-name": "Path 10667",
  d: "M394.9,38.61a2.51,2.51,0,1,0,2.51-2.51A2.506,2.506,0,0,0,394.9,38.61Z",
  transform: "translate(758.539 48.869)",
  fill: "#ffe358"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10668",
  "data-name": "Path 10668",
  d: "M273.083,14.487a2.508,2.508,0,1,0,2.509-2.513A2.508,2.508,0,0,0,273.083,14.487Z",
  transform: "translate(519.423 1.513)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10669",
  "data-name": "Path 10669",
  d: "M181.083,11.64a2.508,2.508,0,1,0,2.51-2.513A2.508,2.508,0,0,0,181.083,11.64Z",
  transform: "translate(338.839 -4.075)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10670",
  "data-name": "Path 10670",
  d: "M13.736,230.279a2.51,2.51,0,1,0,2.51-2.513A2.506,2.506,0,0,0,13.736,230.279Z",
  transform: "translate(10.358 425.085)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10671",
  "data-name": "Path 10671",
  d: "M69.236,249.279a2.51,2.51,0,1,0,2.51-2.512A2.506,2.506,0,0,0,69.236,249.279Z",
  transform: "translate(119.298 462.38)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10672",
  "data-name": "Path 10672",
  d: "M48.583,231.433a2.508,2.508,0,1,0,2.51-2.513A2.508,2.508,0,0,0,48.583,231.433Z",
  transform: "translate(78.758 427.351)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10673",
  "data-name": "Path 10673",
  d: "M480.583,328.514a2.508,2.508,0,1,0,2.51-2.513A2.508,2.508,0,0,0,480.583,328.514Z",
  transform: "translate(926.72 617.908)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10674",
  "data-name": "Path 10674",
  d: "M480.583,300.514a2.508,2.508,0,1,0,2.51-2.512A2.508,2.508,0,0,0,480.583,300.514Z",
  transform: "translate(926.72 562.948)",
  fill: "#ffe358"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10675",
  "data-name": "Path 10675",
  d: "M112.835,44a2.51,2.51,0,1,0,2.51-2.513A2.508,2.508,0,0,0,112.835,44Z",
  transform: "translate(204.877 59.447)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10676",
  "data-name": "Path 10676",
  d: "M45.636,17.222a2.508,2.508,0,1,0,2.507-2.51A2.508,2.508,0,0,0,45.636,17.222Z",
  transform: "translate(72.974 6.887)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10677",
  "data-name": "Path 10677",
  d: "M23.054,97.342a2.51,2.51,0,1,0,2.507-2.51A2.508,2.508,0,0,0,23.054,97.342Z",
  transform: "translate(28.648 164.153)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10678",
  "data-name": "Path 10678",
  d: "M178.045,111.2a2.51,2.51,0,1,0,2.513-2.513A2.509,2.509,0,0,0,178.045,111.2Z",
  transform: "translate(332.876 191.35)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10679",
  "data-name": "Path 10679",
  d: "M359.211,91.183a2.51,2.51,0,1,0,2.51-2.51A2.509,2.509,0,0,0,359.211,91.183Z",
  transform: "translate(688.482 152.063)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10680",
  "data-name": "Path 10680",
  d: "M419.257,58.34a2.51,2.51,0,1,0,2.51-2.513A2.506,2.506,0,0,0,419.257,58.34Z",
  transform: "translate(806.345 87.591)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10683",
  "data-name": "Path 10683",
  d: "M473.416,65.613a2.51,2.51,0,1,0,2.51-2.513A2.506,2.506,0,0,0,473.416,65.613Z",
  transform: "translate(912.652 101.867)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10684",
  "data-name": "Path 10684",
  d: "M392.1,97.274a1.471,1.471,0,1,0,1.47-1.473A1.467,1.467,0,0,0,392.1,97.274Z",
  transform: "translate(753.039 166.055)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10685",
  "data-name": "Path 10685",
  d: "M385.433,71.528a1.471,1.471,0,1,0,1.472-1.473A1.47,1.47,0,0,0,385.433,71.528Z",
  transform: "translate(739.952 115.519)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10686",
  "data-name": "Path 10686",
  d: "M348.263,82.09a1.471,1.471,0,1,0,1.47-1.473A1.468,1.468,0,0,0,348.263,82.09Z",
  transform: "translate(666.992 136.251)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10687",
  "data-name": "Path 10687",
  d: "M346.1,101.094a1.471,1.471,0,1,0,1.47-1.473A1.467,1.467,0,0,0,346.1,101.094Z",
  transform: "translate(662.747 173.553)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10688",
  "data-name": "Path 10688",
  d: "M349.1,116.427a1.471,1.471,0,1,0,1.47-1.473A1.467,1.467,0,0,0,349.1,116.427Z",
  transform: "translate(668.635 203.65)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10689",
  "data-name": "Path 10689",
  d: "M380.263,97.09a1.471,1.471,0,1,0,1.47-1.473A1.467,1.467,0,0,0,380.263,97.09Z",
  transform: "translate(729.804 165.694)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10690",
  "data-name": "Path 10690",
  d: "M443.436,125.442a1.473,1.473,0,1,0,1.473-1.473A1.47,1.47,0,0,0,443.436,125.442Z",
  transform: "translate(853.805 221.345)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10691",
  "data-name": "Path 10691",
  d: "M436.769,99.695a1.473,1.473,0,1,0,1.476-1.473A1.473,1.473,0,0,0,436.769,99.695Z",
  transform: "translate(840.718 170.807)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10692",
  "data-name": "Path 10692",
  d: "M399.6,110.257a1.471,1.471,0,1,0,1.47-1.473A1.467,1.467,0,0,0,399.6,110.257Z",
  transform: "translate(767.76 191.539)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10693",
  "data-name": "Path 10693",
  d: "M431.6,125.257a1.471,1.471,0,1,0,1.47-1.473A1.467,1.467,0,0,0,431.6,125.257Z",
  transform: "translate(830.572 220.982)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10694",
  "data-name": "Path 10694",
  d: "M388.436,50.6a1.473,1.473,0,1,0,1.472-1.473A1.47,1.47,0,0,0,388.436,50.6Z",
  transform: "translate(745.847 74.449)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10695",
  "data-name": "Path 10695",
  d: "M381.769,24.858a1.472,1.472,0,1,0,1.475-1.473A1.472,1.472,0,0,0,381.769,24.858Z",
  transform: "translate(732.76 23.911)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10696",
  "data-name": "Path 10696",
  d: "M344.6,35.42a1.471,1.471,0,1,0,1.47-1.473A1.467,1.467,0,0,0,344.6,35.42Z",
  transform: "translate(659.802 44.643)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10697",
  "data-name": "Path 10697",
  d: "M376.6,50.42a1.471,1.471,0,1,0,1.47-1.473A1.467,1.467,0,0,0,376.6,50.42Z",
  transform: "translate(722.614 74.086)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10698",
  "data-name": "Path 10698",
  d: "M266.267,77.108a1.471,1.471,0,1,0,1.473-1.473A1.468,1.468,0,0,0,266.267,77.108Z",
  transform: "translate(506.045 126.472)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10699",
  "data-name": "Path 10699",
  d: "M259.6,51.361a1.472,1.472,0,1,0,1.472-1.473A1.47,1.47,0,0,0,259.6,51.361Z",
  transform: "translate(492.958 75.933)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10700",
  "data-name": "Path 10700",
  d: "M222.43,61.923a1.471,1.471,0,1,0,1.47-1.473A1.469,1.469,0,0,0,222.43,61.923Z",
  transform: "translate(419.998 96.665)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10701",
  "data-name": "Path 10701",
  d: "M254.43,76.923a1.471,1.471,0,1,0,1.47-1.473A1.469,1.469,0,0,0,254.43,76.923Z",
  transform: "translate(482.81 126.108)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10702",
  "data-name": "Path 10702",
  d: "M309.77,146.108a1.473,1.473,0,1,0,1.476-1.473A1.471,1.471,0,0,0,309.77,146.108Z",
  transform: "translate(591.435 261.91)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10703",
  "data-name": "Path 10703",
  d: "M303.1,120.362a1.474,1.474,0,1,0,1.476-1.473A1.473,1.473,0,0,0,303.1,120.362Z",
  transform: "translate(578.349 211.374)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10704",
  "data-name": "Path 10704",
  d: "M265.934,130.924a1.471,1.471,0,1,0,1.47-1.473A1.469,1.469,0,0,0,265.934,130.924Z",
  transform: "translate(505.391 232.105)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10705",
  "data-name": "Path 10705",
  d: "M297.934,145.924a1.471,1.471,0,1,0,1.47-1.473A1.469,1.469,0,0,0,297.934,145.924Z",
  transform: "translate(568.203 261.549)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10706",
  "data-name": "Path 10706",
  d: "M131.77,306.778a1.473,1.473,0,1,0,1.476-1.473A1.469,1.469,0,0,0,131.77,306.778Z",
  transform: "translate(242.044 577.285)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_527",
  "data-name": "Ellipse 527",
  cx: 1.471,
  cy: 1.471,
  r: 1.471,
  transform: "translate(354.063 806.306)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10707",
  "data-name": "Path 10707",
  d: "M87.934,291.594a1.471,1.471,0,1,0,1.47-1.473A1.471,1.471,0,0,0,87.934,291.594Z",
  transform: "translate(155.999 547.48)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10708",
  "data-name": "Path 10708",
  d: "M119.934,306.594a1.471,1.471,0,1,0,1.47-1.473A1.471,1.471,0,0,0,119.934,306.594Z",
  transform: "translate(218.811 576.923)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10709",
  "data-name": "Path 10709",
  d: "M247.273,289.774a1.473,1.473,0,1,0,1.473-1.473A1.471,1.471,0,0,0,247.273,289.774Z",
  transform: "translate(468.762 543.908)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_528",
  "data-name": "Ellipse 528",
  cx: 1.471,
  cy: 1.471,
  r: 1.471,
  transform: "translate(696.284 755.926)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10710",
  "data-name": "Path 10710",
  d: "M203.436,274.59a1.473,1.473,0,1,0,1.473-1.473A1.474,1.474,0,0,0,203.436,274.59Z",
  transform: "translate(382.715 514.104)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10711",
  "data-name": "Path 10711",
  d: "M235.436,289.59a1.473,1.473,0,1,0,1.473-1.473A1.474,1.474,0,0,0,235.436,289.59Z",
  transform: "translate(445.527 543.547)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10712",
  "data-name": "Path 10712",
  d: "M344.273,299.774a1.473,1.473,0,1,0,1.473-1.473A1.471,1.471,0,0,0,344.273,299.774Z",
  transform: "translate(659.161 563.537)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_529",
  "data-name": "Ellipse 529",
  cx: 1.471,
  cy: 1.471,
  r: 1.471,
  transform: "translate(983.683 785.555)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10713",
  "data-name": "Path 10713",
  d: "M300.436,284.59a1.473,1.473,0,1,0,1.473-1.473A1.474,1.474,0,0,0,300.436,284.59Z",
  transform: "translate(573.114 533.732)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10714",
  "data-name": "Path 10714",
  d: "M319.337,307.09a1.471,1.471,0,1,0,1.47-1.472A1.473,1.473,0,0,0,319.337,307.09Z",
  transform: "translate(610.214 577.899)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10715",
  "data-name": "Path 10715",
  d: "M419.27,294.278a1.473,1.473,0,1,0,1.476-1.473A1.469,1.469,0,0,0,419.27,294.278Z",
  transform: "translate(806.37 552.749)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_530",
  "data-name": "Ellipse 530",
  cx: 1.471,
  cy: 1.471,
  r: 1.471,
  transform: "translate(1205.89 769.27)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10716",
  "data-name": "Path 10716",
  d: "M375.434,279.094a1.471,1.471,0,1,0,1.47-1.473A1.471,1.471,0,0,0,375.434,279.094Z",
  transform: "translate(720.326 522.945)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10717",
  "data-name": "Path 10717",
  d: "M407.434,294.094a1.471,1.471,0,1,0,1.47-1.473A1.471,1.471,0,0,0,407.434,294.094Z",
  transform: "translate(783.137 552.388)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10718",
  "data-name": "Path 10718",
  d: "M175.27,96.278a1.473,1.473,0,1,0,1.475-1.473A1.469,1.469,0,0,0,175.27,96.278Z",
  transform: "translate(327.429 164.1)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_531",
  "data-name": "Ellipse 531",
  cx: 1.471,
  cy: 1.471,
  r: 1.471,
  transform: "translate(482.948 182.621)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10719",
  "data-name": "Path 10719",
  d: "M131.434,81.094a1.471,1.471,0,1,0,1.47-1.473A1.471,1.471,0,0,0,131.434,81.094Z",
  transform: "translate(241.384 134.295)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10720",
  "data-name": "Path 10720",
  d: "M163.434,96.094a1.471,1.471,0,1,0,1.47-1.473A1.471,1.471,0,0,0,163.434,96.094Z",
  transform: "translate(304.196 163.739)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10721",
  "data-name": "Path 10721",
  d: "M78.27,43.278a1.473,1.473,0,1,0,1.476-1.473A1.469,1.469,0,0,0,78.27,43.278Z",
  transform: "translate(137.03 60.067)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_532",
  "data-name": "Ellipse 532",
  cx: 1.471,
  cy: 1.471,
  r: 1.471,
  transform: "translate(195.55 25.589)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10722",
  "data-name": "Path 10722",
  d: "M34.434,28.094a1.471,1.471,0,1,0,1.47-1.473A1.471,1.471,0,0,0,34.434,28.094Z",
  transform: "translate(50.986 30.263)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10723",
  "data-name": "Path 10723",
  d: "M66.434,43.094a1.471,1.471,0,1,0,1.47-1.473A1.471,1.471,0,0,0,66.434,43.094Z",
  transform: "translate(113.798 59.706)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10724",
  "data-name": "Path 10724",
  d: "M313,227.425a1.471,1.471,0,1,0,1.473-1.473A1.47,1.47,0,0,0,313,227.425Z",
  transform: "translate(597.781 421.525)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_533",
  "data-name": "Ellipse 533",
  cx: 1.471,
  cy: 1.471,
  r: 1.471,
  transform: "translate(822.197 585.572)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10725",
  "data-name": "Path 10725",
  d: "M245.934,217.094a1.471,1.471,0,1,0,1.47-1.473A1.471,1.471,0,0,0,245.934,217.094Z",
  transform: "translate(466.133 401.246)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10726",
  "data-name": "Path 10726",
  d: "M429.416,46.613a2.51,2.51,0,1,0,2.51-2.513A2.506,2.506,0,0,0,429.416,46.613Z",
  transform: "translate(826.285 64.572)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10727",
  "data-name": "Path 10727",
  d: "M490.595,10.553A2.508,2.508,0,1,0,493.1,8.04,2.507,2.507,0,0,0,490.595,10.553Z",
  transform: "translate(946.372 -6.209)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10728",
  "data-name": "Path 10728",
  d: "M398.728,172.789a2.511,2.511,0,1,0,2.51-2.515A2.51,2.51,0,0,0,398.728,172.789Z",
  transform: "translate(766.049 312.236)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10729",
  "data-name": "Path 10729",
  d: "M422.817,169.227a2.51,2.51,0,1,0,2.51-2.512A2.508,2.508,0,0,0,422.817,169.227Z",
  transform: "translate(813.332 305.248)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10730",
  "data-name": "Path 10730",
  d: "M285.34,58.883a2.51,2.51,0,1,0,2.51-2.51A2.509,2.509,0,0,0,285.34,58.883Z",
  transform: "translate(543.482 88.663)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10731",
  "data-name": "Path 10731",
  d: "M253.488,92.723a2.511,2.511,0,1,0,2.51-2.51A2.509,2.509,0,0,0,253.488,92.723Z",
  transform: "translate(480.961 155.086)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10732",
  "data-name": "Path 10732",
  d: "M223.209,78.866a2.508,2.508,0,1,0,2.51-2.51A2.509,2.509,0,0,0,223.209,78.866Z",
  transform: "translate(421.527 127.887)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10733",
  "data-name": "Path 10733",
  d: "M217.05,117.36a2.51,2.51,0,1,0,2.507-2.513A2.506,2.506,0,0,0,217.05,117.36Z",
  transform: "translate(409.438 203.44)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10734",
  "data-name": "Path 10734",
  d: "M296.053,97.374a2.508,2.508,0,1,0,2.507-2.51A2.508,2.508,0,0,0,296.053,97.374Z",
  transform: "translate(564.511 164.216)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10735",
  "data-name": "Path 10735",
  d: "M397.222,14.688a2.508,2.508,0,1,0,2.507-2.51A2.509,2.509,0,0,0,397.222,14.688Z",
  transform: "translate(763.093 1.913)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10738",
  "data-name": "Path 10738",
  d: "M354.567,38.941a2.511,2.511,0,1,0,2.513-2.51A2.509,2.509,0,0,0,354.567,38.941Z",
  transform: "translate(679.366 49.519)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10739",
  "data-name": "Path 10739",
  d: "M399.9,30.274a2.511,2.511,0,1,0,2.513-2.51A2.509,2.509,0,0,0,399.9,30.274Z",
  transform: "translate(768.349 32.507)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10740",
  "data-name": "Path 10740",
  d: "M404.081,46.1a2.508,2.508,0,1,0,2.51-2.513A2.508,2.508,0,0,0,404.081,46.1Z",
  transform: "translate(776.556 63.559)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10741",
  "data-name": "Path 10741",
  d: "M325.414,10.761a2.509,2.509,0,1,0,2.512-2.51A2.509,2.509,0,0,0,325.414,10.761Z",
  transform: "translate(622.143 -5.795)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10742",
  "data-name": "Path 10742",
  d: "M100.748,16.1a2.508,2.508,0,1,0,2.51-2.513A2.508,2.508,0,0,0,100.748,16.1Z",
  transform: "translate(181.152 4.673)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10743",
  "data-name": "Path 10743",
  d: "M328.931,95.8a2.51,2.51,0,1,0,2.51-2.513A2.508,2.508,0,0,0,328.931,95.8Z",
  transform: "translate(629.046 161.13)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10744",
  "data-name": "Path 10744",
  d: "M407.934,75.819a2.51,2.51,0,1,0,2.509-2.51A2.507,2.507,0,0,0,407.934,75.819Z",
  transform: "translate(784.119 121.906)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10745",
  "data-name": "Path 10745",
  d: "M493.706,90.7a2.51,2.51,0,1,0,2.512-2.512A2.509,2.509,0,0,0,493.706,90.7Z",
  transform: "translate(952.479 151.119)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10746",
  "data-name": "Path 10746",
  d: "M461.854,124.542a2.51,2.51,0,1,0,2.51-2.51A2.509,2.509,0,0,0,461.854,124.542Z",
  transform: "translate(889.957 217.543)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10747",
  "data-name": "Path 10747",
  d: "M431.574,110.685a2.511,2.511,0,1,0,2.513-2.51A2.51,2.51,0,0,0,431.574,110.685Z",
  transform: "translate(830.521 190.343)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10748",
  "data-name": "Path 10748",
  d: "M425.416,149.179a2.508,2.508,0,1,0,2.509-2.513A2.509,2.509,0,0,0,425.416,149.179Z",
  transform: "translate(818.434 265.896)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10749",
  "data-name": "Path 10749",
  d: "M504.419,129.2a2.508,2.508,0,1,0,2.51-2.513A2.506,2.506,0,0,0,504.419,129.2Z",
  transform: "translate(973.507 226.672)",
  fill: "#ffe358"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10750",
  "data-name": "Path 10750",
  d: "M448.543,180a2.51,2.51,0,1,0,2.512-2.51A2.511,2.511,0,0,0,448.543,180Z",
  transform: "translate(863.829 326.404)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10751",
  "data-name": "Path 10751",
  d: "M456.082,176.457a2.51,2.51,0,1,0,2.512-2.51A2.511,2.511,0,0,0,456.082,176.457Z",
  transform: "translate(878.627 319.445)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10752",
  "data-name": "Path 10752",
  d: "M465.263,181.946a2.51,2.51,0,1,0,2.51-2.513A2.508,2.508,0,0,0,465.263,181.946Z",
  transform: "translate(896.649 330.214)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10753",
  "data-name": "Path 10753",
  d: "M525.263,210.612a2.509,2.509,0,1,0,2.51-2.512A2.508,2.508,0,0,0,525.263,210.612Z",
  transform: "translate(1014.421 386.484)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10754",
  "data-name": "Path 10754",
  d: "M531.6,241.946a2.509,2.509,0,1,0,2.51-2.513A2.508,2.508,0,0,0,531.6,241.946Z",
  transform: "translate(1026.852 447.986)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10755",
  "data-name": "Path 10755",
  d: "M521.6,226.946a2.509,2.509,0,1,0,2.51-2.513A2.508,2.508,0,0,0,521.6,226.946Z",
  transform: "translate(1007.223 418.543)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10756",
  "data-name": "Path 10756",
  d: "M548.93,222.279a2.508,2.508,0,1,0,2.507-2.512A2.508,2.508,0,0,0,548.93,222.279Z",
  transform: "translate(1060.876 409.382)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10757",
  "data-name": "Path 10757",
  d: "M550.082,252.766a2.51,2.51,0,1,0,2.513-2.512A2.511,2.511,0,0,0,550.082,252.766Z",
  transform: "translate(1063.137 469.225)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10758",
  "data-name": "Path 10758",
  d: "M553.235,264.279a2.511,2.511,0,1,0,2.513-2.513A2.509,2.509,0,0,0,553.235,264.279Z",
  transform: "translate(1069.326 491.823)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10759",
  "data-name": "Path 10759",
  d: "M537.749,258.279a2.508,2.508,0,1,0,2.509-2.512A2.508,2.508,0,0,0,537.749,258.279Z",
  transform: "translate(1038.93 480.046)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10760",
  "data-name": "Path 10760",
  d: "M554.416,280.279a2.509,2.509,0,1,0,2.512-2.513A2.509,2.509,0,0,0,554.416,280.279Z",
  transform: "translate(1071.645 523.229)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10761",
  "data-name": "Path 10761",
  d: "M473.263,175.946a2.51,2.51,0,1,0,2.51-2.513A2.508,2.508,0,0,0,473.263,175.946Z",
  transform: "translate(912.351 318.437)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10762",
  "data-name": "Path 10762",
  d: "M485.6,179.612a2.51,2.51,0,1,0,2.51-2.513A2.508,2.508,0,0,0,485.6,179.612Z",
  transform: "translate(936.56 325.633)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10763",
  "data-name": "Path 10763",
  d: "M490.749,186.613a2.508,2.508,0,1,0,2.51-2.513A2.508,2.508,0,0,0,490.749,186.613Z",
  transform: "translate(946.674 339.375)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10764",
  "data-name": "Path 10764",
  d: "M492.749,199.946a2.51,2.51,0,1,0,2.513-2.513A2.509,2.509,0,0,0,492.749,199.946Z",
  transform: "translate(950.6 365.546)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10765",
  "data-name": "Path 10765",
  d: "M504.235,203.613a2.511,2.511,0,1,0,2.513-2.513A2.509,2.509,0,0,0,504.235,203.613Z",
  transform: "translate(973.146 372.743)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10766",
  "data-name": "Path 10766",
  d: "M483.6,217.612a2.51,2.51,0,1,0,2.51-2.513A2.508,2.508,0,0,0,483.6,217.612Z",
  transform: "translate(932.634 400.222)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10767",
  "data-name": "Path 10767",
  d: "M539.863,329.106a2.511,2.511,0,1,0,2.51-2.513A2.511,2.511,0,0,0,539.863,329.106Z",
  transform: "translate(1043.079 619.07)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10768",
  "data-name": "Path 10768",
  d: "M5.6,317.85a2.511,2.511,0,1,0,2.51-2.516A2.511,2.511,0,0,0,5.6,317.85Z",
  transform: "translate(-5.604 596.97)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10769",
  "data-name": "Path 10769",
  d: "M305.355,213.364a2.511,2.511,0,1,0,2.51-2.513A2.508,2.508,0,0,0,305.355,213.364Z",
  transform: "translate(582.769 391.883)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10770",
  "data-name": "Path 10770",
  d: "M279.806,257.112a2.51,2.51,0,1,0,2.507-2.512A2.507,2.507,0,0,0,279.806,257.112Z",
  transform: "translate(532.62 477.757)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10771",
  "data-name": "Path 10771",
  d: "M237.065,302.419a2.511,2.511,0,1,0,2.51-2.513A2.511,2.511,0,0,0,237.065,302.419Z",
  transform: "translate(448.725 566.687)",
  fill: "#48c4f5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10772",
  "data-name": "Path 10772",
  d: "M316.068,251.857a2.51,2.51,0,1,0,2.51-2.515A2.511,2.511,0,0,0,316.068,251.857Z",
  transform: "translate(603.798 467.434)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10773",
  "data-name": "Path 10773",
  d: "M385.417,244.157a2.51,2.51,0,1,0,2.513-2.513A2.509,2.509,0,0,0,385.417,244.157Z",
  transform: "translate(739.921 452.326)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10774",
  "data-name": "Path 10774",
  d: "M353.565,308.578a2.511,2.511,0,1,0,2.509-2.513A2.51,2.51,0,0,0,353.565,308.578Z",
  transform: "translate(677.399 578.776)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10775",
  "data-name": "Path 10775",
  d: "M323.285,264.141a2.51,2.51,0,1,0,2.513-2.515A2.511,2.511,0,0,0,323.285,264.141Z",
  transform: "translate(617.964 491.548)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10776",
  "data-name": "Path 10776",
  d: "M401.233,283.612a2.511,2.511,0,1,0,2.512-2.516A2.509,2.509,0,0,0,401.233,283.612Z",
  transform: "translate(770.966 529.765)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10777",
  "data-name": "Path 10777",
  d: "M317.127,333.212a2.51,2.51,0,1,0,2.509-2.513A2.511,2.511,0,0,0,317.127,333.212Z",
  transform: "translate(605.876 627.13)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10778",
  "data-name": "Path 10778",
  d: "M396.13,313.231a2.51,2.51,0,1,0,2.509-2.516A2.511,2.511,0,0,0,396.13,313.231Z",
  transform: "translate(760.949 587.904)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10779",
  "data-name": "Path 10779",
  d: "M434.686,250.829a2.51,2.51,0,1,0,2.509-2.513A2.508,2.508,0,0,0,434.686,250.829Z",
  transform: "translate(836.63 465.422)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10780",
  "data-name": "Path 10780",
  d: "M464.42,315.247a2.51,2.51,0,1,0,2.513-2.51A2.511,2.511,0,0,0,464.42,315.247Z",
  transform: "translate(894.994 591.873)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10781",
  "data-name": "Path 10781",
  d: "M434.141,301.394a2.51,2.51,0,1,0,2.507-2.515A2.508,2.508,0,0,0,434.141,301.394Z",
  transform: "translate(835.56 564.671)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10782",
  "data-name": "Path 10782",
  d: "M427.414,332.1a2.51,2.51,0,1,0,2.513-2.512A2.511,2.511,0,0,0,427.414,332.1Z",
  transform: "translate(822.356 624.939)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10783",
  "data-name": "Path 10783",
  d: "M506.984,319.9a2.511,2.511,0,1,0,2.513-2.516A2.511,2.511,0,0,0,506.984,319.9Z",
  transform: "translate(978.542 601)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10784",
  "data-name": "Path 10784",
  d: "M170.9,214.611a2.512,2.512,0,1,0,2.512-2.51A2.511,2.511,0,0,0,170.9,214.611Z",
  transform: "translate(318.853 394.337)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10785",
  "data-name": "Path 10785",
  d: "M129.8,249.771a2.51,2.51,0,1,0,2.51-2.515A2.511,2.511,0,0,0,129.8,249.771Z",
  transform: "translate(238.183 463.342)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10786",
  "data-name": "Path 10786",
  d: "M99.523,235.913a2.51,2.51,0,1,0,2.51-2.513A2.511,2.511,0,0,0,99.523,235.913Z",
  transform: "translate(178.747 436.144)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10787",
  "data-name": "Path 10787",
  d: "M93.364,304.985a2.511,2.511,0,1,0,2.513-2.513A2.509,2.509,0,0,0,93.364,304.985Z",
  transform: "translate(166.658 571.724)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10788",
  "data-name": "Path 10788",
  d: "M151.083,254.613A2.51,2.51,0,1,0,153.6,252.1,2.511,2.511,0,0,0,151.083,254.613Z",
  transform: "translate(279.953 472.85)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10789",
  "data-name": "Path 10789",
  d: "M54.393,132.789a2.51,2.51,0,1,0,2.51-2.513A2.51,2.51,0,0,0,54.393,132.789Z",
  transform: "translate(90.163 233.725)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10790",
  "data-name": "Path 10790",
  d: "M547.529,184.11a2.51,2.51,0,1,0,2.51-2.513A2.509,2.509,0,0,0,547.529,184.11Z",
  transform: "translate(1058.126 334.461)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10791",
  "data-name": "Path 10791",
  d: "M535.725,53.753a2.51,2.51,0,1,0,2.51-2.513A2.507,2.507,0,0,0,535.725,53.753Z",
  transform: "translate(1034.957 78.587)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10792",
  "data-name": "Path 10792",
  d: "M12.757,49.645a2.51,2.51,0,1,0,2.513-2.51A2.511,2.511,0,0,0,12.757,49.645Z",
  transform: "translate(8.436 70.53)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10793",
  "data-name": "Path 10793",
  d: "M178.077,53.238a2.511,2.511,0,1,0,2.513-2.51A2.511,2.511,0,0,0,178.077,53.238Z",
  transform: "translate(332.939 77.582)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10794",
  "data-name": "Path 10794",
  d: "M146.226,87.08a2.51,2.51,0,1,0,2.51-2.513A2.506,2.506,0,0,0,146.226,87.08Z",
  transform: "translate(270.419 144.004)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10795",
  "data-name": "Path 10795",
  d: "M552.082,103.624a2.51,2.51,0,1,0,2.513-2.51A2.509,2.509,0,0,0,552.082,103.624Z",
  transform: "translate(1067.063 176.484)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10796",
  "data-name": "Path 10796",
  d: "M480.43,199.779a2.51,2.51,0,1,0,2.51-2.513A2.506,2.506,0,0,0,480.43,199.779Z",
  transform: "translate(926.42 365.218)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10797",
  "data-name": "Path 10797",
  d: "M442.749,164.947a2.51,2.51,0,1,0,2.513-2.513A2.506,2.506,0,0,0,442.749,164.947Z",
  transform: "translate(852.456 296.847)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10798",
  "data-name": "Path 10798",
  d: "M504.235,219.613a2.511,2.511,0,1,0,2.513-2.512A2.506,2.506,0,0,0,504.235,219.613Z",
  transform: "translate(973.146 404.149)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10799",
  "data-name": "Path 10799",
  d: "M550.082,13.291a2.51,2.51,0,1,0,2.513-2.51A2.509,2.509,0,0,0,550.082,13.291Z",
  transform: "translate(1063.137 -0.829)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10800",
  "data-name": "Path 10800",
  d: "M144.082,63.933a2.51,2.51,0,1,0,2.512-2.513A2.509,2.509,0,0,0,144.082,63.933Z",
  transform: "translate(266.211 98.569)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10801",
  "data-name": "Path 10801",
  d: "M79.582,12.791a2.51,2.51,0,1,0,2.512-2.51A2.509,2.509,0,0,0,79.582,12.791Z",
  transform: "translate(139.605 -1.81)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10802",
  "data-name": "Path 10802",
  d: "M115.946,73.223a2.511,2.511,0,1,0,2.51-2.513A2.509,2.509,0,0,0,115.946,73.223Z",
  transform: "translate(210.983 116.804)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10803",
  "data-name": "Path 10803",
  d: "M124.749,97.277a2.51,2.51,0,1,0,2.512-2.51A2.509,2.509,0,0,0,124.749,97.277Z",
  transform: "translate(228.263 164.025)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10804",
  "data-name": "Path 10804",
  d: "M188.79,91.731a2.511,2.511,0,1,0,2.513-2.513A2.511,2.511,0,0,0,188.79,91.731Z",
  transform: "translate(353.967 153.133)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10805",
  "data-name": "Path 10805",
  d: "M391.544,207.686a2.508,2.508,0,1,0,2.509-2.513A2.511,2.511,0,0,0,391.544,207.686Z",
  transform: "translate(751.948 380.738)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10806",
  "data-name": "Path 10806",
  d: "M415.119,142.024a2.51,2.51,0,1,0,2.513-2.509A2.509,2.509,0,0,0,415.119,142.024Z",
  transform: "translate(798.222 251.858)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10807",
  "data-name": "Path 10807",
  d: "M481.837,107.063a2.51,2.51,0,1,0,2.513-2.513A2.509,2.509,0,0,0,481.837,107.063Z",
  transform: "translate(929.181 183.228)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10808",
  "data-name": "Path 10808",
  d: "M78.568,268.945a2.51,2.51,0,1,0,2.51-2.516A2.508,2.508,0,0,0,78.568,268.945Z",
  transform: "translate(137.615 500.976)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10809",
  "data-name": "Path 10809",
  d: "M52.568,290.277a2.51,2.51,0,1,0,2.51-2.515A2.511,2.511,0,0,0,52.568,290.277Z",
  transform: "translate(86.58 542.85)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10810",
  "data-name": "Path 10810",
  d: "M231.934,320.926a2.508,2.508,0,1,0,2.507-2.512A2.508,2.508,0,0,0,231.934,320.926Z",
  transform: "translate(438.653 603.016)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10811",
  "data-name": "Path 10811",
  d: "M239.086,217.954a2.51,2.51,0,1,0,2.513-2.518A2.513,2.513,0,0,0,239.086,217.954Z",
  transform: "translate(452.692 400.883)",
  fill: "#ffe358"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10812",
  "data-name": "Path 10812",
  d: "M310.423,192.8a2.508,2.508,0,1,0,2.507-2.512A2.513,2.513,0,0,0,310.423,192.8Z",
  transform: "translate(592.717 351.523)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10813",
  "data-name": "Path 10813",
  d: "M69.789,301.422a2.508,2.508,0,1,0,2.51-2.51A2.511,2.511,0,0,0,69.789,301.422Z",
  transform: "translate(120.383 564.736)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10814",
  "data-name": "Path 10814",
  d: "M74.407,333.246a2.511,2.511,0,1,0,2.513-2.515A2.511,2.511,0,0,0,74.407,333.246Z",
  transform: "translate(129.448 627.193)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10815",
  "data-name": "Path 10815",
  d: "M64.624,232.9a2.51,2.51,0,1,0,2.513-2.518A2.513,2.513,0,0,0,64.624,232.9Z",
  transform: "translate(110.245 430.226)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10816",
  "data-name": "Path 10816",
  d: "M163.915,174.46a2.51,2.51,0,1,0,2.513-2.513A2.514,2.514,0,0,0,163.915,174.46Z",
  transform: "translate(305.141 315.52)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10817",
  "data-name": "Path 10817",
  d: "M58.98,99.975a2.508,2.508,0,1,0,2.507-2.513A2.506,2.506,0,0,0,58.98,99.975Z",
  transform: "translate(99.166 169.315)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10818",
  "data-name": "Path 10818",
  d: "M143.179,132.273a2.51,2.51,0,1,0,2.507-2.51A2.508,2.508,0,0,0,143.179,132.273Z",
  transform: "translate(264.438 232.718)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10819",
  "data-name": "Path 10819",
  d: "M70.751,59.4a2.51,2.51,0,1,0,2.51-2.513A2.511,2.511,0,0,0,70.751,59.4Z",
  transform: "translate(122.271 89.668)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10820",
  "data-name": "Path 10820",
  d: "M13.93,145.78a2.51,2.51,0,1,0,2.507-2.515A2.509,2.509,0,0,0,13.93,145.78Z",
  transform: "translate(10.739 259.221)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10821",
  "data-name": "Path 10821",
  d: "M80.833,165.03a2.51,2.51,0,1,0,2.51-2.513A2.508,2.508,0,0,0,80.833,165.03Z",
  transform: "translate(142.061 297.01)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10822",
  "data-name": "Path 10822",
  d: "M124.583,198.436a2.51,2.51,0,1,0,2.51-2.518A2.51,2.51,0,0,0,124.583,198.436Z",
  transform: "translate(227.937 362.572)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10823",
  "data-name": "Path 10823",
  d: "M124.235,160.032a2.511,2.511,0,1,0,2.51-2.518A2.507,2.507,0,0,0,124.235,160.032Z",
  transform: "translate(227.254 287.19)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10824",
  "data-name": "Path 10824",
  d: "M259.735,118.782a2.511,2.511,0,1,0,2.51-2.518A2.508,2.508,0,0,0,259.735,118.782Z",
  transform: "translate(493.223 206.221)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10825",
  "data-name": "Path 10825",
  d: "M203.735,153.782a2.511,2.511,0,1,0,2.51-2.518A2.507,2.507,0,0,0,203.735,153.782Z",
  transform: "translate(383.302 274.922)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10826",
  "data-name": "Path 10826",
  d: "M439.083,213.436a2.51,2.51,0,1,0,2.509-2.518A2.51,2.51,0,0,0,439.083,213.436Z",
  transform: "translate(845.26 392.015)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10827",
  "data-name": "Path 10827",
  d: "M512.735,266.783a2.511,2.511,0,1,0,2.509-2.518A2.508,2.508,0,0,0,512.735,266.783Z",
  transform: "translate(989.83 496.726)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10828",
  "data-name": "Path 10828",
  d: "M359.583,242.936a2.51,2.51,0,1,0,2.509-2.518A2.51,2.51,0,0,0,359.583,242.936Z",
  transform: "translate(689.212 449.92)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10829",
  "data-name": "Path 10829",
  d: "M390.748,295.793a2.51,2.51,0,1,0,2.51-2.515A2.51,2.51,0,0,0,390.748,295.793Z",
  transform: "translate(750.385 553.677)",
  fill: "#ffe358"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10830",
  "data-name": "Path 10830",
  d: "M95.6,274.947a2.51,2.51,0,1,0,2.507-2.518A2.509,2.509,0,0,0,95.6,274.947Z",
  transform: "translate(171.037 512.751)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10831",
  "data-name": "Path 10831",
  d: "M11.583,181.936a2.51,2.51,0,1,0,2.51-2.518A2.51,2.51,0,0,0,11.583,181.936Z",
  transform: "translate(6.132 330.184)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10832",
  "data-name": "Path 10832",
  d: "M142.088,11.611A2.51,2.51,0,1,0,144.6,9.1,2.508,2.508,0,0,0,142.088,11.611Z",
  transform: "translate(262.297 -4.132)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10833",
  "data-name": "Path 10833",
  d: "M463.009,143.292a3.652,3.652,0,1,0,3.65-3.65A3.651,3.651,0,0,0,463.009,143.292Z",
  transform: "translate(892.224 252.109)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10834",
  "data-name": "Path 10834",
  d: "M405.015,179.732a3.65,3.65,0,1,0,3.65-3.653A3.648,3.648,0,0,0,405.015,179.732Z",
  transform: "translate(778.389 323.63)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10835",
  "data-name": "Path 10835",
  d: "M116.587,242.342a3.653,3.653,0,1,0,3.65-3.65A3.655,3.655,0,0,0,116.587,242.342Z",
  transform: "translate(212.242 446.532)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10836",
  "data-name": "Path 10836",
  d: "M27.8,329.379a3.653,3.653,0,1,0,3.653-3.653A3.653,3.653,0,0,0,27.8,329.379Z",
  transform: "translate(37.964 617.368)",
  fill: "#48c4f5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10837",
  "data-name": "Path 10837",
  d: "M408.607,313.467a3.652,3.652,0,1,0,3.653-3.65A3.656,3.656,0,0,0,408.607,313.467Z",
  transform: "translate(785.44 586.141)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10838",
  "data-name": "Path 10838",
  d: "M339.731,219.081a6.492,6.492,0,1,0,6.495-6.495A6.492,6.492,0,0,0,339.731,219.081Z",
  transform: "translate(650.245 395.289)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_534",
  "data-name": "Ellipse 534",
  cx: 2.841,
  cy: 2.841,
  r: 2.841,
  transform: "translate(520.576 182.413)",
  fill: "#d55549"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_536",
  "data-name": "Ellipse 536",
  cx: 2.841,
  cy: 2.841,
  r: 2.841,
  transform: "translate(706.25 457.095)",
  fill: "#d55549"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10839",
  "data-name": "Path 10839",
  d: "M228.218,175.28a7.545,7.545,0,1,0,7.546-7.546A7.547,7.547,0,0,0,228.218,175.28Z",
  transform: "translate(431.359 307.25)",
  fill: "#d55549"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_537",
  "data-name": "Ellipse 537",
  cx: 2.841,
  cy: 2.841,
  r: 2.841,
  transform: "translate(541.195 827.331)",
  fill: "#d55549"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_538",
  "data-name": "Ellipse 538",
  cx: 2.841,
  cy: 2.841,
  r: 2.841,
  transform: "translate(1073.525 853.011)",
  fill: "#d55549"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_539",
  "data-name": "Ellipse 539",
  cx: 2.841,
  cy: 2.841,
  r: 2.841,
  transform: "translate(138.365 245.62)",
  fill: "#d55549"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10840",
  "data-name": "Path 10840",
  d: "M440.238,315.5A6.492,6.492,0,1,0,446.733,309,6.493,6.493,0,0,0,440.238,315.5Z",
  transform: "translate(847.528 584.543)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10841",
  "data-name": "Path 10841",
  d: "M357.4,291.1a6.492,6.492,0,1,0,6.495-6.492A6.5,6.5,0,0,0,357.4,291.1Z",
  transform: "translate(684.933 536.665)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_540",
  "data-name": "Ellipse 540",
  cx: 6.493,
  cy: 6.493,
  rx: 6.493,
  ry: 6.493,
  transform: "translate(130.764 154.071)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_541",
  "data-name": "Ellipse 541",
  cx: 6.493,
  cy: 6.493,
  rx: 6.493,
  ry: 6.493,
  transform: "translate(1603.313 655.711)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_542",
  "data-name": "Ellipse 542",
  cx: 6.493,
  cy: 6.493,
  rx: 6.493,
  ry: 6.493,
  transform: "translate(77.433 503.69)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10842",
  "data-name": "Path 10842",
  d: "M107.93,333.83a6.492,6.492,0,1,0,6.492-6.495A6.489,6.489,0,0,0,107.93,333.83Z",
  transform: "translate(195.249 620.527)",
  fill: "#b9e0f1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10843",
  "data-name": "Path 10843",
  d: "M256.524,303.414a10.62,10.62,0,1,0,10.622-10.619A10.618,10.618,0,0,0,256.524,303.414Z",
  transform: "translate(486.92 552.729)",
  fill: "#b9e0f1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2263",
  "data-name": "Group 2263",
  transform: "translate(170.83 50.736)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_10844",
  "data-name": "Path 10844",
  d: "M167.636,60.892a6.6,6.6,0,0,0,5.855-5.852c.2-2.453,1.837-13.259,1.837-13.259s1.4,10.835,1.84,13.259c.652,3.591,2.791,5.425,5.855,5.849,2.438.335,13.256,1.846,13.256,1.843s-10.817,1.523-13.256,1.846a6.26,6.26,0,0,0-5.846,5.849c-.329,2.435-1.849,13.259-1.849,13.259s-1.6-10.812-1.849-13.259a6.4,6.4,0,0,0-5.843-5.852c-2.447-.273-13.259-1.843-13.259-1.843S165.191,61.173,167.636,60.892Z",
  transform: "translate(115.588 9.284)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10845",
  "data-name": "Path 10845",
  d: "M435.728,247.928a10.371,10.371,0,0,0,9.188-9.185c.308-3.846,2.88-20.8,2.88-20.8s2.2,17,2.889,20.8c1.019,5.641,4.376,8.512,9.182,9.179,3.822.524,20.8,2.895,20.8,2.895s-16.968,2.385-20.8,2.889c-6.11.812-8.575,4.711-9.173,9.179-.516,3.822-2.9,20.8-2.9,20.8s-2.5-16.957-2.895-20.8a10.059,10.059,0,0,0-9.173-9.188c-3.837-.421-20.8-2.886-20.8-2.88S431.894,248.37,435.728,247.928Z",
  transform: "translate(627.019 355.076)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10846",
  "data-name": "Path 10846",
  d: "M77.981,286.992a7.327,7.327,0,0,0,6.5-6.5c.219-2.72,2.038-14.714,2.038-14.714s1.561,12.026,2.047,14.714c.717,3.991,3.093,6.024,6.492,6.495,2.705.367,14.72,2.047,14.72,2.047s-12.011,1.689-14.72,2.044a6.957,6.957,0,0,0-6.489,6.495c-.361,2.705-2.05,14.714-2.05,14.714s-1.772-12-2.047-14.714a7.123,7.123,0,0,0-6.489-6.5c-2.714-.3-14.72-2.042-14.72-2.035S75.267,287.306,77.981,286.992Z",
  transform: "translate(-63.261 448.968)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10847",
  "data-name": "Path 10847",
  d: "M330.326,41.129a4.059,4.059,0,0,0,3.594-3.6c.124-1.508,1.129-8.142,1.129-8.142s.862,6.655,1.132,8.142a4,4,0,0,0,3.594,3.594c1.5.2,8.142,1.132,8.142,1.132s-6.643.933-8.142,1.132a3.853,3.853,0,0,0-3.594,3.594c-.2,1.5-1.132,8.142-1.132,8.142s-.981-6.64-1.132-8.142a3.942,3.942,0,0,0-3.591-3.6c-1.5-.163-8.145-1.132-8.145-1.129S328.824,41.3,330.326,41.129Z",
  transform: "translate(585.954 -29.39)",
  fill: "#fff"
})));

var SvgStars = function SvgStars(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 261,
    viewBox: "0 0 768 261",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_16",
    "data-name": "Mask Group 16",
    transform: "translate(-1152 -827)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(1217.223 906.56)",
    clipPath: "url(#clip-path-2)",
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _ref3)));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStars, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stars.df42e9a5.svg";
export { ForwardRef as ReactComponent };